let videoUtils = {
    /**
     * Set Video Config Object
     * @param {String} releaseURL - Release Url 
     */
    addVideoPlayerElement: (releaseURL, endcardFeed, currentUrl, category, pageName, tag) => {
        let iu = '/fscom/' + category + '/video';
        let site = 'www.foxsports.com/' + category + '/video';
        let videoConfig = {
            iu: iu,
            categoryName: category,
            siteSection: site,
            isFwEnabled: true,
            hideMeta: false,
            share: true,
            share_embed: true,
            endcard: true,
            endcard_feed: endcardFeed,
            endcard_countdown: true,
            releaseURL: releaseURL,
            pageLocation: 'index',
            pageName: pageName,
            autoplay: true,
            tag: tag,
            url: currentUrl
        }

        let videoEl = document.createElement('div');
        videoEl.setAttribute('id', 'video');
        videoEl.setAttribute('class', 'platformPlayer');
        videoEl.setAttribute('data-player-config', JSON.stringify(videoConfig));
        videoEl.setAttribute('enable-pinning', '');
        return videoEl;
    },
    /**
     * Set Video Config Object by using an existing object
     * @param {String} videoPlayerConfig - Video player configuration
     */
    addVideoPlayerElementByConfig: (videoPlayerConfig) => {

        let videoEl = document.createElement('div');
        videoEl.setAttribute('id', 'video');
        videoEl.setAttribute('class', 'platformPlayer');
        videoEl.setAttribute('data-player-config', videoPlayerConfig);
        videoEl.setAttribute('enable-pinning', '');
        return videoEl;
    },
    /**
     *  Loads the video player
     */
    videoLoader: (criticaLoader) => {
        let objs = [];
        if (criticaLoader) {
            //get video players of the page. 
            objs = criticaLoader.getVideoElementsData().map((data) => {
                return data;
            });
        }
        if (typeof FDM_Player !== 'undefined') {
            criticaLoader.loadVideos(FDM_Player, objs);
        } else {
            criticaLoader.loadScript(criticaLoader.loadVideos.bind(criticaLoader), objs);
        }
    },


    //wrappers for video pinning
    createPinWrapperEl() {

        let fsPlayer = document.createElement('div');
        let playerWrapper = document.createElement('div');
        fsPlayer.className = "fs-player";
        playerWrapper.className = "platformPlayer-wrapper";

        fsPlayer.appendChild(playerWrapper);

        return fsPlayer;
    }
}

export default videoUtils;


// WEBPACK FOOTER //
// ./assets/components/fsUtils/videoUtils.js